<template>
    <div
        class="w-full fixed bottom-0 left-0 right-0 lg:relative p-3 flex items-center justify-between lg:rounded-xl"
        :style="{
            'background-color': player.headerColor,
        }"
    >
        <button
            @click="setCurrentFile({ file: previousFile })"
            type="button"
            :style="{
                color: player.headingColor,
                'border-color': player.borderColor,
            }"
            class="relative inline-flex items-center px-3.5 md:pr-4 py-2.5 rounded-lg border text-sm font-medium group"
            :class="[previousFile.id ? '' : 'invisible']"
        >
            <div
                class="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-10 transition-all"
                :style="{
                    'background-color': player.mainColor,
                }"
            ></div>
            <ArrowLeftIcon class="h-5 w-5 md:mr-2 transform transition-all" />
            <div class="hidden md:block">
                <cUtilsEdit @edit="goToLayoutField('playerPrevBtnTitle')">
                    <span>{{ player.prevBtnTitle }}</span>
                </cUtilsEdit>
            </div>
        </button>
        <button
            @click="$emit('toggleFinish')"
            type="button"
            :style="{
                color: player.headingColor,
                'border-color': player.borderColor,
            }"
            class="relative inline-flex items-center px-3.5 md:pr-4 py-2.5 rounded-lg border text-sm font-medium group"
        >
            <div
                class="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-10 transition-all"
                :style="{
                    'background-color': player.mainColor,
                }"
            ></div>
            <span
                :style="{
                    color: player.headingColor,
                    'border-color': isWatched ? '#079455' : player.borderColor,
                    'background-color': isWatched ? '#079455' : 'transparent',
                }"
                class="h-5 w-5 border rounded-full flex items-center justify-center sm:mr-2"
            >
                <CheckIcon v-if="isWatched" class="text-white h-4 w-4" />
            </span>

            <cUtilsEdit class="hidden sm:block" @edit="goToLayoutField('playerMarkDoneLabel')">
                <span>
                    {{ isWatched ? player.finishedLabel : player.markDoneLabel }}
                </span>
            </cUtilsEdit>
        </button>
        <button
            @click="setCurrentFile({ file: nextFile })"
            type="button"
            :style="{
                color: player.headingColor,
                'border-color': player.borderColor,
            }"
            class="relative inline-flex items-center px-3.5 md:pl-4 py-2.5 rounded-lg border text-sm font-medium group"
            :class="[nextFile.id ? '' : 'invisible']"
        >
            <div
                class="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-10 transition-all"
                :style="{
                    'background-color': player.mainColor,
                }"
            ></div>
            <div class="hidden md:block">
                <cUtilsEdit @edit="goToLayoutField('playerNextBtnTitle')">
                    <span>{{ player.nextBtnTitle }}</span>
                </cUtilsEdit>
            </div>
            <ArrowRightIcon class="h-5 w-5 md:ml-2" />
        </button>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon } from "@easy/ui/icons";
import { usePlayerGoTo } from "@/views/tools/player/utils/usePlayerGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    components: {
        ArrowLeftIcon,
        ArrowRightIcon,
        CheckIcon,
        cUtilsEdit,
    },
    setup() {
        const { goToLayoutField } = usePlayerGoTo();
        return { goToLayoutField };
    },
    computed: {
        ...mapState("player/view", ["player"]),
        ...mapGetters("player/view", ["isWatched", "noHeadersFiles", "currentFile"]),
        currentIndex() {
            return this.player.files.indexOf(this.currentFile);
        },
        previousFile() {
            const currentIndex = this.noHeadersFiles.indexOf(this.currentFile);
            if (currentIndex > 0) {
                return this.noHeadersFiles[currentIndex - 1];
            }
            return { id: null };
        },
        nextFile() {
            const currentIndex = this.noHeadersFiles.indexOf(this.currentFile);
            if (currentIndex < this.noHeadersFiles.length - 1) {
                return this.noHeadersFiles[currentIndex + 1];
            }
            return { id: null };
        },
    },
    emits: ["toggleFinish"],
    methods: {
        ...mapMutations("player/view", ["setCurrentFile"]),
    },
};
</script>
